import { SuggestionItem, ESuggestionType } from '@obeta/data/lib/hooks'

import { useMemo } from 'react'

type SuggestionOptions = {
  query: string
  highlightedOption?: SuggestionItem | null
  autocompleteOptions?: SuggestionItem[]
}

export const useSuggestionOption = (options: SuggestionOptions) => {
  const matchOption = (query: string, option?: SuggestionItem | null) => {
    if (!option || ![ESuggestionType.Suggestion, ESuggestionType.History].includes(option.type)) {
      return false
    }

    const title = option.title.toLowerCase()

    return title.startsWith(query) && title !== query
  }

  const suggestionOption = useMemo(() => {
    const query = options.query.trim().toLowerCase()
    const { highlightedOption, autocompleteOptions = [] } = options

    if (!query) {
      return null
    }

    if (!highlightedOption) {
      const firstMatchingOption = autocompleteOptions.find((option) => matchOption(query, option))
      return firstMatchingOption ?? null
    }

    if (matchOption(query, highlightedOption)) {
      return highlightedOption
    }

    return null
  }, [options])

  return suggestionOption
}
